// Invoice line-item generation (incl. the summarized-billing collapse) lives in @onward-delivery/core
// (accounting.js) — the single source of truth shared with onward-functions. That covers the Electrolux
// and MasterBrand custom exports too: their columns and row generation are in core so the browser
// download and the NetSuite attachment cannot drift apart. This module keeps only the helpers that are
// specific to onward-web export views: per-order rows for CompletedOrders and the delimited-text
// formatter.
import { format } from 'date-fns';
import { saveAs } from 'file-saver';
import {
    generateLineItems,
    generateLineItemsFromBreakdown,
    generatePelotonRows,
    PELOTON_COLUMNS,
    serializeDelimited,
} from '@onward-delivery/core';

export { generateLineItems };
export {
    generateElectroluxRows,
    generateMasterbrandRows,
    isMasterbrandExportEnabled,
    isPelotonExportEnabled,
} from '@onward-delivery/core';

// Serialized by core, like the NetSuite attachment and the Peloton SFTP upload, so all three files
// are byte-identical.
export const downloadPelotonCsv = (invoices, filenameBase) => {
    const csv = serializeDelimited(generatePelotonRows(invoices), PELOTON_COLUMNS);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, `${filenameBase}-peloton-${format(new Date(), 'yyyy-MM-dd')}.csv`);
};

export const generateLineItemsOrders = (orders) => {
    let lineItems = [];
    (orders || []).forEach((fullOrder) => {
        const { price_breakdown, ...order } = fullOrder;
        let rows = [];

        rows.push(...generateLineItemsFromBreakdown(order, price_breakdown?.shipperBreakdown, 'Freight Charge'));
        rows.push(
            ...generateLineItemsFromBreakdown(order, price_breakdown?.mmShipperBreakdown, 'Freight Charge (LTL)')
        );
        rows.push(
            ...generateLineItemsFromBreakdown(
                order,
                price_breakdown?.whShipperBreakdown,
                'Warehouse Consolidation Charge'
            )
        );

        lineItems.push(...rows.map((row) => ({ row, order })));
    });
    return lineItems.filter(({ row }) => !!row.total);
};

export const buildDelimitedText = (rows, columns, { delimiter = '\t', lineEnding = '\n' } = {}) => {
    const header = columns.map((col) => col.header).join(delimiter);
    const lines = rows.map((row) =>
        columns
            .map((col) => {
                const value = col.getValue(row);
                return col.format ? col.format(value) : value ?? '';
            })
            .join(delimiter)
    );
    return [header, ...lines].join(lineEnding);
};
